<template>
  <div class="progress">
    <div class="graphic">
      <ProgressCircle
        :size="36"
        :stroke="3"
        :progress="progress"
        class="progress"
      />
    </div>
    <span class="label">{{ label }}</span>
  </div>
</template>
<script setup lang="ts">
interface Props {
  count: number;
  total: number;
}
const props = defineProps({
  count: null,
  total: null
});

const label = computed(() => `${props.count}/${props.total}`);

const progress = computed(() => props.count / props.total);
</script>
<style lang="scss" scoped>
.progress {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.label {
  @include font('xxs', 700, 'secondary');

  opacity: 0.4;
  color: var(--color_secondary);
}
.graphic {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -1.8rem;
  margin-left: -1.8rem;
}
</style>
